import { roundDecimalSignificantsUp } from './numbers.js';
function parseNum(value) {
    if (value == null)
        return NaN;
    if (typeof value === 'number')
        return value;
    return parseFloat(value.toString().replace(/[^\d.-]/gu, ''));
}
const defaultOptions = {
    locale: 'en-US',
    localeMatcher: 'best fit',
    useGrouping: true,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
};
const exludeOptionsForIntlConstructor = {
    format: undefined,
    code: undefined,
    symbol: undefined,
};
const formatters = new Map();
const formatNumber = (number, opts) => {
    const options = Object.assign(Object.create(null), defaultOptions, opts, exludeOptionsForIntlConstructor);
    number = parseNum(number);
    if (isNaN(number)) {
        if (opts?.nanZero === false)
            return 'NaN';
        number = 0;
    }
    const key = JSON.stringify(options);
    if (!formatters.has(key)) {
        Object.keys(options).forEach(function (key) {
            if (!key.includes('minimum') && key.startsWith('min')) {
                options[key.replace('min', 'minimum')] = options[key];
                delete options[key];
            }
            if (!key.includes('maximum') && key.startsWith('max')) {
                options[key.replace('max', 'maximum')] = options[key];
                delete options[key];
            }
        });
        Object.keys(options).forEach(function (key) {
            if (key.startsWith('minimum') && !key.endsWith('Digits')) {
                options[key + 'Digits'] = options[key];
                delete options[key];
            }
            if (key.startsWith('maximum') && !key.endsWith('Digits')) {
                options[key + 'Digits'] = options[key];
                delete options[key];
            }
        });
        if (options.maximumSignificantDigits) {
            options.maximumSignificantDigits = Math.min(options.maximumSignificantDigits, 21);
        }
        const locale = options.locale ?? 'en-US';
        formatters.set(key, new Intl.NumberFormat([locale], { ...options, style: 'decimal' }));
    }
    if (globalThis.Intl === globalThis.IntlPolyfill) {
        const maxSignificant = Math.min(options.maximumSignificantDigits ?? 21, 21);
        number = roundDecimalSignificantsUp(number, maxSignificant);
    }
    return formatters.get(key).format(number);
};
export default function formatCurrency(amount, opts) {
    amount = formatNumber(amount, opts);
    if (!opts?.format || opts.format === '%v')
        return amount;
    const { format = '%v', symbol, code } = opts;
    if (!format.includes('%v'))
        throw new Error('Must have "%v" in `format` options.');
    return format
        .replace('%v', amount)
        .replace('%s', symbol || '')
        .replace('%c', code || '');
}
